import { URLS } from '../../env/urls';
import { sendServerRequest } from '../../server/request';
import {
  WAAccount,
  IGAccount,
  CreateWAAccountRequest,
  CreateIGAccountRequest,
  UpdateWAAccountRequest,
  UpdateIGAccountRequest,
  AccountsListResponse,
  V8Login,
} from '../../types/admin';

// Lista os V8 logins disponíveis para atrelar a uma conta (rota dedicada do admin).
export async function listV8Logins(): Promise<V8Login[]> {
  const result = await sendServerRequest('GET', URLS.admin.accounts.v8.list);
  return result.data.data.v8s ?? [];
}

// WhatsApp Accounts
export const waAccountsApi = {
  async create(data: CreateWAAccountRequest): Promise<WAAccount> {
    const result = await sendServerRequest('POST', URLS.admin.accounts.wa.create, data);
    return result.data.data;
  },

  async list(page: number = 0, limit: number = 20): Promise<AccountsListResponse<WAAccount>> {
    const url = `${URLS.admin.accounts.wa.list}?page=${page}&limit=${limit}`;
    const result = await sendServerRequest('GET', url);
    const payload = result.data.data;
    // O backend WA responde { numbers, total, page, limit, pages }.
    return {
      accounts: payload.numbers ?? [],
      total: payload.total,
      page: payload.page,
      limit: payload.limit,
      pages: payload.pages,
    };
  },

  async getById(id: number): Promise<WAAccount> {
    const url = URLS.admin.accounts.wa.get(id);
    const result = await sendServerRequest('GET', url);
    // O backend WA responde { number }.
    return result.data.data.number;
  },

  async update(id: number, data: UpdateWAAccountRequest): Promise<WAAccount> {
    const url = URLS.admin.accounts.wa.update(id);
    const result = await sendServerRequest('PUT', url, data);
    return result.data.data;
  },

  async delete(id: number): Promise<void> {
    const url = URLS.admin.accounts.wa.delete(id);
    await sendServerRequest('DELETE', url);
  },

  async toggle(id: number): Promise<{ id: number; is_active: boolean }> {
    const url = URLS.admin.accounts.wa.toggle(id);
    const result = await sendServerRequest('PATCH', url);
    return result.data.data;
  },

  async toggleShots(id: number): Promise<{ id: number; allow_shots: boolean }> {
    const url = URLS.admin.accounts.wa.toggleShots(id);
    const result = await sendServerRequest('PATCH', url);
    return result.data.data;
  },
};

// Instagram Accounts
export const igAccountsApi = {
  async create(data: CreateIGAccountRequest): Promise<IGAccount> {
    const result = await sendServerRequest('POST', URLS.admin.accounts.ig.create, data);
    return result.data.data;
  },

  async list(page: number = 0, limit: number = 20): Promise<AccountsListResponse<IGAccount>> {
    const url = `${URLS.admin.accounts.ig.list}?page=${page}&limit=${limit}`;
    const result = await sendServerRequest('GET', url);
    // O backend IG responde { accounts, total, page, limit, pages }.
    return result.data.data;
  },

  async getById(id: number): Promise<IGAccount> {
    const url = URLS.admin.accounts.ig.get(id);
    const result = await sendServerRequest('GET', url);
    return result.data.data.account;
  },

  async update(id: number, data: UpdateIGAccountRequest): Promise<IGAccount> {
    const url = URLS.admin.accounts.ig.update(id);
    const result = await sendServerRequest('PUT', url, data);
    return result.data.data;
  },

  async delete(id: number): Promise<void> {
    const url = URLS.admin.accounts.ig.delete(id);
    await sendServerRequest('DELETE', url);
  },

  async toggle(id: number): Promise<{ id: number; is_active: boolean }> {
    const url = URLS.admin.accounts.ig.toggle(id);
    const result = await sendServerRequest('PATCH', url);
    return result.data.data;
  },
};
